import { Button, ButtonMode, ButtonSize, Icon, ICONS, Tooltip } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import { ReactElement } from 'react';
import styles from './MoreButton.module.scss';

const cx = classNames.bind(styles);

type MoreButtonProps = {
  handleToggle: () => void;
  hiddenCheckedKeysCount: number;
  isExpanded: boolean;
};

const MoreButton = ({ handleToggle, hiddenCheckedKeysCount, isExpanded }: MoreButtonProps): ReactElement => {
  const renderContent = () => (
    <div className={cx('content')} data-testid="more-btn-content">
      {hiddenCheckedKeysCount ? (
        <span className={cx('count')} data-testid="more-button-count">
          {hiddenCheckedKeysCount}
        </span>
      ) : (
        <Icon name={ICONS.Filters} width={12} height={12} dataTestId="more-btn-icon" />
      )}
      {isExpanded ? 'Less' : 'More'}
    </div>
  );

  const renderTooltip = (
    <div className="content">
      <span>{hiddenCheckedKeysCount} additional</span>
      <span>{hiddenCheckedKeysCount === 1 ? 'filter' : 'filters'} applied</span>
    </div>
  );

  return (
    <Button
      className={cx('body')}
      onClick={handleToggle}
      mode={ButtonMode.SECONDARY}
      size={ButtonSize.SMALL}
      dataTestId="more-btn"
    >
      <Tooltip content={renderTooltip} disabled={isExpanded || !hiddenCheckedKeysCount} trigger={renderContent()} />
    </Button>
  );
};

export default MoreButton;
